module.exports = __webpack_public_path__ + "static/img/logo2.2c501772.png";